// frontend/src/AdminIcerikYonetimi.js
// Admin: karşılama (landing) sayfası içerik yönetimi.
// (Trafik istatistikleri Genel Bakış / Dashboard sayfasındadır.)
import React, { useState, useEffect, useCallback } from 'react';
import { Card, Button, Form, Row, Col, Spinner, Alert } from 'react-bootstrap';
import api from './api';

const BOS_ICERIK = { video_url: '', ekran_goruntuleri: [], yorumlar: [], istatistikler: [] };

function AdminIcerikYonetimi() {
  const [icerik, setIcerik] = useState(BOS_ICERIK);
  const [loading, setLoading] = useState(true);
  const [yuklemeHatasi, setYuklemeHatasi] = useState(false);
  const [kaydediliyor, setKaydediliyor] = useState(false);
  const [error, setError] = useState('');
  const [basari, setBasari] = useState('');

  const icerikGetir = useCallback(async () => {
    setLoading(true);
    setYuklemeHatasi(false);
    try {
      const res = await api.get('/admin/ayarlar/landing');
      setIcerik({ ...BOS_ICERIK, ...res.data });
    } catch (err) {
      setYuklemeHatasi(true);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { icerikGetir(); }, [icerikGetir]);

  // --- Liste yardımcıları ---
  const listeEkle = (alan, yeni) => setIcerik((o) => ({ ...o, [alan]: [...(o[alan] || []), yeni] }));
  const listeSil = (alan, idx) => setIcerik((o) => ({ ...o, [alan]: o[alan].filter((_, i) => i !== idx) }));
  const listeGuncelle = (alan, idx, anahtar, deger) => setIcerik((o) => ({
    ...o,
    [alan]: o[alan].map((item, i) => (i === idx ? { ...item, [anahtar]: deger } : item)),
  }));

  const gorselYukle = (idx, dosya) => {
    if (!dosya) return;
    if (dosya.size > 2 * 1024 * 1024) {
      alert('Görsel 2 MB\'tan büyük. Lütfen daha küçük/optimize bir görsel yükleyin.');
      return;
    }
    const reader = new FileReader();
    reader.onload = (e) => listeGuncelle('ekran_goruntuleri', idx, 'gorsel', e.target.result);
    reader.readAsDataURL(dosya);
  };

  const kaydet = async () => {
    setKaydediliyor(true);
    setError('');
    setBasari('');
    try {
      await api.put('/admin/ayarlar/landing', icerik);
      setBasari('Karşılama sayfası içeriği kaydedildi.');
      setTimeout(() => setBasari(''), 4000);
    } catch (err) {
      setError(err.response?.data?.mesaj || 'Kaydetme başarısız oldu.');
    } finally {
      setKaydediliyor(false);
    }
  };

  if (loading) {
    return <Spinner animation="border" style={{ color: 'var(--accent-primary)' }} />;
  }

  if (yuklemeHatasi) {
    return (
      <div>
        <div className="mb-4">
          <h2 className="fw-bolder m-0" style={{ color: 'var(--text-main)' }}>Karşılama Sayfası</h2>
          <p className="m-0" style={{ color: 'var(--text-muted)' }}>Tanıtım içeriğini yönetin.</p>
        </div>
        <Alert variant="danger">
          İçerik yüklenemedi. Sunucu uykudan uyanıyor olabilir; birkaç saniye sonra tekrar deneyin.
          <div className="mt-2">
            <Button size="sm" variant="outline-danger" onClick={icerikGetir}>Tekrar Dene</Button>
          </div>
        </Alert>
      </div>
    );
  }

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap gap-2">
        <div>
          <h2 className="fw-bolder m-0" style={{ color: 'var(--text-main)' }}>Karşılama Sayfası</h2>
          <p className="m-0" style={{ color: 'var(--text-muted)' }}>Tanıtım içeriğini yönetin. (Trafik istatistikleri Genel Bakış sayfasındadır.)</p>
        </div>
        <Button onClick={kaydet} disabled={kaydediliyor} style={{ backgroundColor: 'var(--accent-primary)', border: 'none', color: '#fff' }} className="fw-bold d-flex align-items-center gap-2">
          {kaydediliyor ? <Spinner size="sm" animation="border" /> : <span className="material-symbols-outlined">save</span>}
          Kaydet
        </Button>
      </div>

      {error && <Alert variant="danger" onClose={() => setError('')} dismissible>{error}</Alert>}
      {basari && <Alert variant="success">{basari}</Alert>}

      {/* Tanıtım videosu */}
      <Card className="glass-card mb-3" style={{ border: 'none' }}>
        <Card.Body className="p-4">
          <h6 className="fw-bold mb-1" style={{ color: 'var(--text-main)' }}>Tanıtım Videosu</h6>
          <p style={{ color: 'var(--text-muted)', fontSize: '0.85rem' }}>YouTube linki yapıştırın (örn. https://www.youtube.com/watch?v=...). Boş bırakılırsa video bölümü gizlenir.</p>
          <Form.Control
            type="url"
            placeholder="https://www.youtube.com/watch?v=..."
            value={icerik.video_url || ''}
            onChange={(e) => setIcerik((o) => ({ ...o, video_url: e.target.value }))}
          />
        </Card.Body>
      </Card>

      {/* İstatistikler */}
      <Card className="glass-card mb-3" style={{ border: 'none' }}>
        <Card.Body className="p-4">
          <div className="d-flex justify-content-between align-items-center mb-2">
            <h6 className="fw-bold m-0" style={{ color: 'var(--text-main)' }}>İstatistikler <span style={{ color: 'var(--text-muted)', fontWeight: 400, fontSize: '0.8rem' }}>(hero altında rozet olarak görünür)</span></h6>
            <Button size="sm" variant="outline-secondary" onClick={() => listeEkle('istatistikler', { deger: '', etiket: '' })}>+ Ekle</Button>
          </div>
          {(icerik.istatistikler || []).length === 0 && <p className="m-0" style={{ color: 'var(--text-muted)', fontSize: '0.85rem' }}>Eklenmedi. Boşsa bölüm gizli kalır.</p>}
          {(icerik.istatistikler || []).map((s, i) => (
            <Row className="g-2 mb-2 align-items-center" key={i}>
              <Col xs={5}><Form.Control placeholder="Değer (örn. 500+)" value={s.deger} onChange={(e) => listeGuncelle('istatistikler', i, 'deger', e.target.value)} /></Col>
              <Col xs={6}><Form.Control placeholder="Etiket (örn. Aktif diyetisyen)" value={s.etiket} onChange={(e) => listeGuncelle('istatistikler', i, 'etiket', e.target.value)} /></Col>
              <Col xs={1} className="text-end"><Button variant="link" className="p-0 text-danger" onClick={() => listeSil('istatistikler', i)}><span className="material-symbols-outlined">delete</span></Button></Col>
            </Row>
          ))}
        </Card.Body>
      </Card>

      {/* Ekran görüntüleri */}
      <Card className="glass-card mb-3" style={{ border: 'none' }}>
        <Card.Body className="p-4">
          <div className="d-flex justify-content-between align-items-center mb-2">
            <h6 className="fw-bold m-0" style={{ color: 'var(--text-main)' }}>Ekran Görüntüleri <span style={{ color: 'var(--text-muted)', fontWeight: 400, fontSize: '0.8rem' }}>(en fazla 8, her biri &lt; 2 MB)</span></h6>
            <Button size="sm" variant="outline-secondary" disabled={(icerik.ekran_goruntuleri || []).length >= 8} onClick={() => listeEkle('ekran_goruntuleri', { baslik: '', aciklama: '', gorsel: '' })}>+ Ekle</Button>
          </div>
          {(icerik.ekran_goruntuleri || []).length === 0 && <p className="m-0" style={{ color: 'var(--text-muted)', fontSize: '0.85rem' }}>Eklenmedi. Boşsa "Ürünü Görün" bölümü gizli kalır.</p>}
          {(icerik.ekran_goruntuleri || []).map((g, i) => (
            <Row className="g-2 mb-3 align-items-start pb-3" key={i} style={{ borderBottom: '1px solid var(--border-color, rgba(128,128,128,0.15))' }}>
              <Col md={3}>
                {g.gorsel
                  ? <img src={g.gorsel} alt="önizleme" style={{ width: '100%', borderRadius: 8, border: '1px solid rgba(128,128,128,0.2)' }} />
                  : <div style={{ width: '100%', aspectRatio: '16/10', borderRadius: 8, background: 'rgba(128,128,128,0.1)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--text-muted)' }}><span className="material-symbols-outlined">image</span></div>}
                <Form.Control type="file" accept="image/*" size="sm" className="mt-2" onChange={(e) => gorselYukle(i, e.target.files[0])} />
              </Col>
              <Col md={8}>
                <Form.Control className="mb-2" placeholder="Başlık (örn. Danışan paneli)" value={g.baslik} onChange={(e) => listeGuncelle('ekran_goruntuleri', i, 'baslik', e.target.value)} />
                <Form.Control as="textarea" rows={2} placeholder="Kısa açıklama" value={g.aciklama} onChange={(e) => listeGuncelle('ekran_goruntuleri', i, 'aciklama', e.target.value)} />
              </Col>
              <Col md={1} className="text-end"><Button variant="link" className="p-0 text-danger" onClick={() => listeSil('ekran_goruntuleri', i)}><span className="material-symbols-outlined">delete</span></Button></Col>
            </Row>
          ))}
        </Card.Body>
      </Card>

      {/* Yorumlar */}
      <Card className="glass-card mb-4" style={{ border: 'none' }}>
        <Card.Body className="p-4">
          <div className="d-flex justify-content-between align-items-center mb-2">
            <h6 className="fw-bold m-0" style={{ color: 'var(--text-main)' }}>Danışan/Diyetisyen Yorumları <span style={{ color: 'var(--text-muted)', fontWeight: 400, fontSize: '0.8rem' }}>(en fazla 12)</span></h6>
            <Button size="sm" variant="outline-secondary" disabled={(icerik.yorumlar || []).length >= 12} onClick={() => listeEkle('yorumlar', { isim: '', unvan: '', metin: '' })}>+ Ekle</Button>
          </div>
          {(icerik.yorumlar || []).length === 0 && <p className="m-0" style={{ color: 'var(--text-muted)', fontSize: '0.85rem' }}>Eklenmedi. Boşsa "Ne Diyor?" bölümü gizli kalır.</p>}
          {(icerik.yorumlar || []).map((y, i) => (
            <Row className="g-2 mb-3 align-items-start pb-3" key={i} style={{ borderBottom: '1px solid var(--border-color, rgba(128,128,128,0.15))' }}>
              <Col md={5}>
                <Form.Control className="mb-2" placeholder="İsim (örn. Dyt. Ayşe Yılmaz)" value={y.isim} onChange={(e) => listeGuncelle('yorumlar', i, 'isim', e.target.value)} />
                <Form.Control placeholder="Ünvan (örn. Beslenme Uzmanı)" value={y.unvan} onChange={(e) => listeGuncelle('yorumlar', i, 'unvan', e.target.value)} />
              </Col>
              <Col md={6}>
                <Form.Control as="textarea" rows={3} placeholder="Yorum metni" value={y.metin} onChange={(e) => listeGuncelle('yorumlar', i, 'metin', e.target.value)} />
              </Col>
              <Col md={1} className="text-end"><Button variant="link" className="p-0 text-danger" onClick={() => listeSil('yorumlar', i)}><span className="material-symbols-outlined">delete</span></Button></Col>
            </Row>
          ))}
        </Card.Body>
      </Card>

      <div className="text-end mb-5">
        <Button onClick={kaydet} disabled={kaydediliyor} style={{ backgroundColor: 'var(--accent-primary)', border: 'none', color: '#fff' }} className="fw-bold d-flex align-items-center gap-2 ms-auto">
          {kaydediliyor ? <Spinner size="sm" animation="border" /> : <span className="material-symbols-outlined">save</span>}
          Kaydet
        </Button>
      </div>
    </div>
  );
}

export default AdminIcerikYonetimi;
